import React from 'react';
import { useDispatch } from 'react-redux';

import { DeleteOutline } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { useImmer } from 'use-immer';

import { updateEnchiridionPdfContentRequest } from '../../../../store/modules/enchiridion/actions';
import { updateInspectionSheetPdfContentRequest } from '../../../../store/modules/inspections/actions';
import { Container, ShadowButton } from './styles';

export default function Hidrostatico({ initialState, stateIndex, action }) {
  const dispatchActions = useDispatch();

  const [state, setState] = useImmer(initialState);

  function handleAdd() {
    setState((prevState) => {
      prevState[0].stack.push({ style: 'justify', text: '\u200B\t\t\t', exclude: true });
    });
  }

  function handleRemove(id) {
    if (state[0].stack.length > 1) {
      setState((prevState) => {
        prevState[0].stack = state[0].stack.filter((_, index) => index !== id);
      });
    } else {
      alert('Não é permitido remover todos os elementos');
    }
  }

  function handleUpdate() {
    switch (action) {
      case 'inspectionSheet':
        dispatchActions(
          updateInspectionSheetPdfContentRequest({ contentIndex: stateIndex, pdfContent: state }),
        );
        break;
      case 'enchiridion':
        dispatchActions(
          updateEnchiridionPdfContentRequest({ contentIndex: stateIndex, pdfContent: state }),
        );
        break;
      default:
        break;
    }
  }

  function getText(text) {
    if (typeof text === 'string') {
      return text;
    }

    if (typeof text === 'object') {
      try {
        return text.text || JSON.stringify(text, undefined, 2);
      } catch (err) {
        return text;
      }
    }

    return text;
  }

  return (
    <div>
      {state && Array.isArray(state) && state[0] ? (
        <Container>
          <div>
            {state[0].stack && Array.isArray(state[0].stack)
              ? state[0].stack.map((element, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div key={index}>
                  {index >= 1 ? (
                    <li>
                      <textarea
                        style={{ width: '100%', marginRight: 10 }}
                        value={getText(element.text)}
                        onChange={(e) => {
                          setState((prevState) => {
                            prevState[0].stack[index].text = getText(e.target.value);
                          });
                          e.persist();
                        }}
                      />
                      {element.exclude ? (
                        <ShadowButton
                          type="button"
                          width="30px"
                          height="30px"
                          borderRadius="50%"
                          background="#db3a3a"
                          color="#f5f5f5"
                          onClick={() => handleRemove(index)}
                        >
                          <DeleteOutline />
                        </ShadowButton>
                      ) : null}
                    </li>
                  ) : null}
                </div>
              ))
              : null}

            {state[1] && state[1].text ? (
              <li>
                <textarea
                  style={{ width: '100%', marginRight: 10, height: 80 }}
                  value={getText(state[1].text)}
                  onChange={(e) => {
                    setState((prevState) => {
                      prevState[1].text = getText(e.target.value);
                    });
                  }}
                />
              </li>
            ) : null}
          </div>
          <div
            style={{
              width: 150,
              marginTop: 10,
              alignSelf: 'flex-end',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <ShadowButton
              onClick={handleAdd}
              type="button"
              width="30px"
              height="30px"
              borderRadius="50%"
              background="#4CAF50"
              color="#f5f5f5"
            >
              +
            </ShadowButton>

            <ShadowButton
              onClick={handleUpdate}
              width="180px"
              height="40px"
              background="#4CAF50"
              color="#f5f5f5"
              style={{ marginTop: 10 }}
            >
              Salvar Alterações
            </ShadowButton>
          </div>
        </Container>
      ) : null}
    </div>
  );
}

Hidrostatico.propTypes = {
  initialState: PropTypes.arrayOf(
    PropTypes.shape({
      unbreakable: PropTypes.bool,
      stack: PropTypes.arrayOf(
        PropTypes.shape({
          text: PropTypes.string,
        }),
        PropTypes.shape({
          text: PropTypes.string,
        }),
      ),
    }),
    PropTypes.shape({
      unbreakable: PropTypes.bool,
      stack: PropTypes.arrayOf(
        PropTypes.shape({
          image: PropTypes.string,
        }),
        PropTypes.shape({
          text: PropTypes.string,
        }),
      ),
    }),
  ),

  stateIndex: PropTypes.number.isRequired,
  action: PropTypes.string.isRequired,
};

Hidrostatico.defaultProps = {
  initialState: [
    {
      unbreakable: true,
      stack: [
        {
          text: '',
        },
        {
          text: '',
        },
      ],
    },
    {
      unbreakable: true,
      stack: [
        {
          image: '',
        },
        {
          text: '',
        },
      ],
    },
  ],
};
